module.exports = __webpack_public_path__ + "img/bg_banner_terms_page.450f0637.png";